<script setup>
defineProps({
  selectedTeams: {
    type: Array,
    default: () => [],
  },
  teamConfigs: {
    type: Object,
    required: true,
  },
  routingTypes: {
    type: Array,
    default: () => [],
  },
  agentBots: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['updateConfig']);
const defaultTeamId = defineModel('defaultTeamId', {
  type: [Number, String],
  default: null,
});

const updateConfig = (teamId, field, value) => {
  emit('updateConfig', { teamId, field, value });
};
</script>

<template>
  <table class="w-full border-collapse table-fixed">
    <colgroup>
      <col class="w-[26%]" />
      <col class="w-[30%]" />
      <col class="w-[30%]" />
      <col class="w-[14%]" />
    </colgroup>
    <thead>
      <tr class="border-b border-n-weak">
        <th class="px-3 pb-3 text-left text-xs font-medium text-n-slate-11">
          {{ $t('INBOX_MGMT.TEAMS.ROUTING.TEAM') }}
        </th>
        <th class="px-3 pb-3 text-left text-xs font-medium text-n-slate-11">
          {{ $t('INBOX_MGMT.TEAMS.ROUTING.ROUTING_TYPE') }}
        </th>
        <th class="px-3 pb-3 text-left text-xs font-medium text-n-slate-11">
          {{ $t('INBOX_MGMT.TEAMS.ROUTING.BOT') }}
        </th>
        <th class="px-3 pb-3 text-center text-xs font-medium text-n-slate-11">
          {{ $t('INBOX_MGMT.TEAMS.ROUTING.DEFAULT') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="team in selectedTeams" :key="team.id">
        <td class="px-3 pt-4 text-sm text-n-slate-12 truncate">
          {{ team.name }}
        </td>

        <td class="px-3 pt-4">
          <div
            v-if="teamConfigs[team.id]"
            class="rounded-lg outline outline-1 -outline-offset-1 outline-n-weak hover:outline-n-strong"
          >
            <select
              :value="teamConfigs[team.id].routing_type_id"
              class="reset-base !mb-0 !border-0 !outline-none !bg-transparent !shadow-none !py-2.5 !px-3 !h-auto !leading-normal text-sm text-n-slate-12"
              @change="
                updateConfig(team.id, 'routing_type_id', $event.target.value)
              "
            >
              <option value="">
                {{ $t('INBOX_MGMT.TEAMS.ROUTING.NO_ROUTING_TYPE') }}
              </option>
              <option v-for="rt in routingTypes" :key="rt.id" :value="rt.id">
                {{ rt.name }}
              </option>
            </select>
          </div>
        </td>

        <td class="px-3 pt-4">
          <div
            v-if="teamConfigs[team.id]"
            class="rounded-lg outline outline-1 -outline-offset-1 outline-n-weak hover:outline-n-strong"
          >
            <select
              :value="teamConfigs[team.id].agent_bot_id"
              class="reset-base !mb-0 !border-0 !outline-none !bg-transparent !shadow-none !py-2.5 !px-3 !h-auto !leading-normal text-sm text-n-slate-12"
              @change="
                updateConfig(team.id, 'agent_bot_id', $event.target.value)
              "
            >
              <option value="">
                {{ $t('INBOX_MGMT.TEAMS.ROUTING.NO_BOT') }}
              </option>
              <option v-for="bot in agentBots" :key="bot.id" :value="bot.id">
                {{ bot.name }}
              </option>
            </select>
          </div>
        </td>

        <td class="px-3 pt-4">
          <div class="flex justify-center">
            <input
              v-model="defaultTeamId"
              type="radio"
              name="defaultTeam"
              :value="team.id"
              class="w-4 h-4 cursor-pointer accent-n-teal-9"
            />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
